var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManufacturers = function SvgManufacturers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M20.007 20.5V4.204a1.2 1.2 0 0 0-1.2-1.2h-7.603a1.2 1.2 0 0 0-1.2 1.2V20.5M22 21H2M13.005 9.501h4m-4-3h4m-4 6h4m-4 3h4M4.001 20.5V8.005a1 1 0 0 1 1-1H10",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgManufacturers;